(ns renolit-roofing-service.user
  (:require [dev.gethop.session.re-frame.cognito.token :as session.token]
            [re-frame.core :as rf]
            [renolit-roofing-service.service.notification :as srv.notification]
            [renolit-roofing-service.util :as util]))

(rf/reg-sub
 ::user-data
 (fn [db _]
   (get db :user)))

(rf/reg-event-fx
 ::on-create-user-success
 []
 (fn [{:keys [db]} [_ on-success-evt {:keys [user]}]]
   (cond-> {:db (assoc db :user user)
            :fx []}

     on-success-evt
     (update :fx conj [:dispatch on-success-evt]))))

(rf/reg-event-fx
 ::on-update-user-success
 []
 (fn [{:keys [_db]} [_ on-success-evt]]
   (cond-> {:fx []}

     on-success-evt
     (update :fx conj [:dispatch on-success-evt]))))

(rf/reg-event-fx
 ::create-user
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [session]} [_ user {:keys [on-success-evt on-failure-evt]}]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :post
                 :params user
                 :uri "/api/user"
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::on-create-user-success on-success-evt]
                 :on-failure [::util/generic-error-with-callback on-failure-evt {}]}}))

(rf/reg-event-fx
 ::update-user
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [session]} [_ user {:keys [on-success-evt on-failure-evt]}]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :put
                 :params user
                 :uri "/api/user"
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::on-update-user-success on-success-evt]
                 :on-failure [::util/generic-error-with-callback on-failure-evt {}]}}))

(rf/reg-event-fx
 ::on-user-data-load-success
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [db session]} [_ on-success-evt {:keys [user]}]]
   (cond-> {:db (assoc db :user user)
            :fx [[:make-websocket-chsk (get-in session [:id-token :jwt])]
                 [:dispatch [::srv.notification/get-notifications-unread-count]]]}

     on-success-evt
     (update :fx conj [:dispatch on-success-evt]))))

(defn- fetch-user-data-event-fx
  "This event handler gets jwt-token from session cofx instead of appdb.
  It is so because at times the token may not be present in appdb yet when
  ::ensure-data is called."
  [{:keys [session]} [_ {:keys [on-success-evt on-failure-evt]}]]
  (if-not session
    {:fx [[:dispatch [::util/generic-error-with-callback on-failure-evt {}]]]}
    {:http-xhrio
     {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
      :method :get
      :uri "/api/user"
      :response-format (util/ajax-transit-response-format)
      :on-success [::on-user-data-load-success on-success-evt]
      :on-failure [::util/generic-error-with-callback on-failure-evt {}]}}))

(rf/reg-event-fx
 ::fetch-user-data
 [(rf/inject-cofx ::session.token/session)]
 fetch-user-data-event-fx)
